// removed by extract-text-webpack-plugin
module.exports = {"topButtonsContainer":"_1aEQaAzN3LQQQAtcqX71zh","loadingwrapper":"_31IQK3i7_44lp5ThvpFL9B","loader":"_1mR_e-FGICvuJqoSD5LCcc","spin":"_3QLd82mERipJqkRF6I_pVb"};


//////////////////
// WEBPACK FOOTER
// ./src/views/SimpleSearch/style.css
// module id = 1105
// module chunks = 0